export const motionPrinciples = [
  {
    title: 'Beweging met een doel',
    body: 'Beweging toont toestand, aandacht of voortgang. Niets draait in een lus om druk te lijken.',
  },
  {
    title: 'Opgeroepen uit Anna',
    body: 'Kaarten komen uit Anna’s richting met een korte veer (250–350 ms) en keren in haar terug als je ze wegveegt.',
  },
  {
    title: 'Lagen van diepte',
    body: 'Achtergrondsfeer, kaarten op het podium, ondertitels op de voorgrond. Subtiele parallax, geen 3D-trucs.',
  },
  {
    title: 'Data beweegt mee',
    body: 'Tellers rollen, voortgang vult, grafieken tekenen. Alleen als de waarde echt verandert.',
  },
  {
    title: 'Beperkte beweging',
    body: 'Alleen vervagen, geen verplaatsing of schaal. Anna blijft levend: ze ademt via helderheid.',
  },
];

export const motionTokens = [
  { name: 'Kaart oproepen', value: 'Veer · ~300 ms', detail: 'stiffness 380 · damping 30, vanuit Anna’s richting' },
  { name: 'Kaart terug naar Anna', value: '250 ms', detail: 'cubic-bezier(0.23, 1, 0.32, 1), krimpt en vervaagt' },
  { name: 'Ondertitel', value: '280 ms per woord', detail: 'In sync met de spraak, vervaagt 6 s na het laatste woord' },
  { name: 'Teller rolt', value: '240 ms', detail: 'Oude waarde schuift weg, nieuwe schuift in' },
  { name: 'Voortgang vult', value: 'Lineair, continu', detail: 'Volgt de echte voortgang van de taak' },
  { name: 'Grafiek tekent', value: '300 ms', detail: 'Lijn tekent van links naar rechts bij nieuwe data' },
  { name: 'Popover · Waarom?', value: '160 ms', detail: 'Vanaf schaal 0.96 en doorzichtig' },
  { name: 'Ademhaling Rust', value: 'Cyclus van 5 s', detail: 'Continu, stopt nooit abrupt' },
];
